module.exports = __webpack_public_path__ + "img/img-3.6c43bc7a.webp";